import { css } from '@emotion/react';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { ButtonComponent } from '~/_shared/baseComponents/buttons';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { RangeType } from '~/_shared/utils/range/range.helpers';
import {
  BOUNDARY_MAX_VALUE_ID, BOUNDARY_MIN_VALUE_ID,
} from '~/boundary/settings/boundarySettings.helpers';
import type { ModalProps } from '~/modal/modalType.enum';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { BoundaryFillSettingsNumericalGeneralComponent } from '../../boundary/customizeFills/boundaryFillSettingsNumericalGeneral.component';

const modalContentStyle = css({
  padding: 0,
});

const containerStyle = css({
  width: '100%',
});

export const DataLayerFillEditModalComponent = ({
  boundaryTerritoryGroup,
  isOpen,
  isSubmitDisabled,
  onClose,
  onBoundaryTerritoryGroupChange,
  onNumberOfRangesChange,
  onSubmitClick,
}: ModalProps<{
  isSubmitDisabled?: boolean;
  boundaryTerritoryGroup: BoundaryTerritoryGroup;
  onNumberOfRangesChange: (numberOfRanges: number) => void;
  onBoundaryTerritoryGroupChange: (territoryGroup: BoundaryTerritoryGroup) => void;
  onSubmitClick: () => void;
}>) => {
  const [t] = useTranslation();

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      caption={t('Fill Settings')}
      contentStyle={modalContentStyle}
      confirmButton={(
        <ButtonComponent
          prefixIcon={faCheck}
          text={t('Save')}
          onClick={onSubmitClick}
          isDisabled={isSubmitDisabled}
        />
      )}
    >
      <div css={containerStyle}>
        <BoundaryFillSettingsNumericalGeneralComponent
          boundaryTerritoryGroup={boundaryTerritoryGroup}
          isDecimal={false}
          disableRangeTypeChange
          rangeMax={BOUNDARY_MAX_VALUE_ID}
          rangeMin={BOUNDARY_MIN_VALUE_ID}
          rangeType={RangeType.Percentage}
          onBoundaryTerritoryGroupChange={onBoundaryTerritoryGroupChange}
          onNumberOfRangesChange={onNumberOfRangesChange}
        />
      </div>
    </ModalComponent>
  );
};
